'use client';

import type { ElementType } from 'react';
import { Button, Stack } from '@mui/material';

import { useT } from '@/hooks';

interface BrowseFiltersListItem {
  label: string;
  icon: ElementType;
  path?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

interface BrowseFiltersListProps {
  filters: BrowseFiltersListItem[];
  onFilterClick: (filter: BrowseFiltersListItem) => void;
  title: string;
}

export const BrowseFiltersList = ({ filters, onFilterClick, title }: BrowseFiltersListProps) => {
  const { t } = useT();
  const renderFilterButton = (filter: BrowseFiltersListItem) => {
    const Icon = filter.icon;

    const handleClick = () => {
      onFilterClick(filter);
    };

    return (
      <Button
        key={filter.label}
        variant="text"
        startIcon={<Icon sx={{ fontSize: '1.2rem' }} />}
        onClick={handleClick}
        sx={{
          justifyContent: 'flex-start',
          color: 'text.primary',
          textTransform: 'none',
          fontSize: '0.9375rem',
          fontWeight: 500,
          py: 1,
          px: 2,
          borderRadius: 4,
          '&:hover': {
            bgcolor: 'action.hover',
          },
          '& .MuiButton-startIcon': {
            mr: 1,
            color: 'text.primary',
          },
        }}
      >
        {t(`search.${filter.label.toLowerCase()}`)}
      </Button>
    );
  };

  const renderFilters = filters.map(renderFilterButton);

  return (
    <Stack
      direction={'row'}
      sx={{
        gap: 2,
      }}
    >
      {renderFilters}
    </Stack>
  );
};
